export default __webpack_public_path__ + "static/media/promotion-decoration-2.a206f68b.svg";